import React, { LegacyRef } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table-6';
import { MdSync } from 'react-icons/md';

import '../../styles/4-components/_react-table.scss';
import './OrderListTable.scss';
import 'react-table-6/react-table.css';
import { useTableHeight } from '../../hooks/useTableHeight';
import { BundleStats } from '../../types/bundleTypes';
import { ReqEnum } from '../../const/requestStatus';
import { createBundlesDataColumns } from './Columns/createBundlesDataColumns';
import { DownloadCSVDrivingTable } from './utils/DownloadCSV';

const tableWrapper = React.createRef();
let reactTable: any = React.createRef();

export function BundleDataListTable({
  bundles,
  fetchStatus = ReqEnum.INIT,
}: {
  bundles: BundleStats[];
  fetchStatus: ReqEnum;
}): JSX.Element {
  const columns = createBundlesDataColumns();

  const [tableHeight] = useTableHeight(tableWrapper);

  const pagination = bundles.length >= 100;

  const isLoading = fetchStatus === ReqEnum.PENDING;

  return (
    <div className={isLoading ? 'orderlisttable is-loading' : 'orderlisttable'}>
      <div className="orderlisttable__header">
        <div className="orderlisttable__header__totals">
          <p>
            <em>Antall ordre:</em> <span>{bundles.length}</span>
          </p>
        </div>

        <DownloadCSVDrivingTable columns={columns} reactTable={reactTable} />
      </div>
      <div
        ref={tableWrapper as LegacyRef<HTMLDivElement>}
        className="u-print-height-auto"
        style={{
          height: tableHeight,
        }}
      >
        <ReactTable
          ref={r => (reactTable = r)}
          data={bundles}
          resizable={false}
          pageSize={pagination ? 100 : bundles.length}
          showPagination={pagination}
          className="-striped -highlight"
          previousText="Forrige"
          nextText="Neste"
          loadingText="Henter ordre..."
          noDataText="Fant ingen ordre"
          pageText="Side"
          ofText="av"
          rowsText="ordre"
          //pageJumpText="gå til side"
          //rowsSelectorText="ordre per side"
          column={{
            ...ReactTableDefaults.column,
            minWidth: 0,
          }}
          columns={columns}
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) === filter.value
          }
          filterable
        >
          {(state, makeTable, instance) => {
            let recordsInfoText = '';

            const { filtered, pageRows, pageSize, sortedData, page } = state;

            if (sortedData && sortedData.length > 0) {
              const isFiltered = filtered.length > 0;

              const totalRecords = sortedData.length;

              const recordsCountFrom = page * pageSize + 1;

              const recordsCountTo = recordsCountFrom + pageRows.length - 1;

              if (isFiltered)
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
              else
                recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
            } else recordsInfoText = 'No records';

            return (
              <div className="main-grid">
                <div className="above-table text-right">
                  <div className="col-sm-12">
                    <span className="records-info">{recordsInfoText}</span>
                  </div>
                </div>

                {makeTable()}
              </div>
            );
          }}
        </ReactTable>
      </div>
      <div className="orderlisttable__spinner">
        <MdSync />
      </div>
    </div>
  );
}
